import { nanoid } from 'nanoid'
import { Button, Icon, Typography } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { EnhancedPromptModal, type IEnhancedPromptModalProps } from './EnhancedPromptModal'
import styles from './styles.module.scss'

export type IEnhancePromptProps = Omit<IEnhancedPromptModalProps, 'onClose'>

export const EnhancePrompt = (props: IEnhancePromptProps) => {
  const onEnhancePrompt = async () => {
    if (!props.prompt.trim()) {
      props.setError('Add instructions for your Agent')
      return
    }
    const modalId = nanoid()

    const onClose = () => {
      modalStore.closeModal(modalId)
    }

    modalStore.addModal({
      id: modalId,
      customTitle: (
        <div className={styles.modalHeaderTitle} aria-label='EnhancedPromptTitle'>
          <Icon icon='stars' color='var(--purple-70)' fontSize={12} />
          <Typography variant={'body-sm-medium'} ariaLabel={'title'} className={styles.headerText}>
            Enhanced prompt
          </Typography>
        </div>
      ),
      width: '800px',
      pureContent: true,
      ModalContent: () => <EnhancedPromptModal onClose={onClose} {...props} />,
    })
  }

  return (
    <Button
      text={'Enhance'}
      typeBtn='link'
      contained='primary'
      onClick={onEnhancePrompt}
      icon={'stars'}
      size='small'
    />
  )
}
